// extracted by mini-css-extract-plugin
module.exports = {"transparentSection":"androidAppDevelopment_transparentSection__1T2nf"};